// extracted by mini-css-extract-plugin
module.exports = {"Container":"Number_Container__172-m","Icon":"Number_Icon__3ZXzz"};